var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab-box"},_vm._l((_vm.infoList),function(item,index){return _c('div',{key:index,staticClass:"tab-item",class:{
      active: index === _vm.activeIndex,
      unread: _vm.isAdd && _vm.readList.indexOf(item.archives_onjob_id) === -1,
      error: _vm.checkResult[index] === -1,
    },on:{"click":function($event){return _vm.changeTabIndex(index)}}},[(item.passport_content.surname_cn || item.passport_content.name_cn)?_c('span',[_vm._v(_vm._s(item.passport_content.surname_cn)+_vm._s(item.passport_content.name_cn))]):_c('span',[_vm._v("未命名")])])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a7ff3bf","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/on-job/components/edit-on-job-tab.vue
// module id = null
// module chunks = 